/* global $, window, document */
import debounce from 'lodash/debounce';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	const handleComponents = (components) => {
		components.forEach((component) => {
			const displaySubcategories = !!component.getAttribute('data-display-subcategories');
			if (displaySubcategories) {
				handleRowSizing(component);

				window.addEventListener('resize', debounce(() => {
					handleRowSizing(component);
				}, 250));
			}
		});
	};

	const handleRowSizing = (component) => {
		// clear any existing row sizing
		component.querySelectorAll('.category-wrapper').forEach((category) => {
			for(let i = 0; i <= 4; i++) {
				category.classList.remove('subcat-max-' + i);
			}
		});

		// collect list of category wrappers by row
		const rows = [];
		let row = 0;
		let lastComponent = null;
		component.querySelectorAll('.category-wrapper').forEach((category) => {
			if (!lastComponent) {
				lastComponent = category;
				rows[row] = [category];
				return;
			}
			if (category.offsetTop === lastComponent.offsetTop) {
				// if the category is on the same row as the last one, add it to the row
				rows[row].push(category);
			} else {
				// otherwise, create a new row
				row++;
				rows[row] = [category];
			}
			lastComponent = category;
		});

		for(let rowidx in rows) {
			const row = rows[rowidx];
			// get the height of the tallest category in the row
			let mostSubcats = 0;
			row.forEach((category) => {
				const subcats = category.querySelectorAll('.subcategory-wrapper ul li');
				const subcatsCount = subcats.length;
				if (subcatsCount > mostSubcats) {
					mostSubcats = subcatsCount;
				}
			});

			// set the height of all categories in the row to the tallest
			row.forEach((category) => {
				category.classList.add('subcat-max-' + mostSubcats);
			});
		}
	};

	/********************************************
	 * Load Javascript for the Category Tiles Component
	 * -----------------------------------------
	 * @section category_tiles_js
	 ********************************************/
	(function CategoryTilesComponent() {
		$onReady({
			rp$, window,
			label: 'category_tiles',
			fn: function() {
				// Const Variables
				const $arrowSize = 20;
				const $arrowWidth = 15;
				const categoryMarginBottom = 40;
				const mobileExperienceBreakpoint = 767;  // Taken from variables.scss

				let $lastOpenCategory = null;
				let $lastOpenDropdown = null;

				const components = document.querySelectorAll('.category-tiles-component');
				handleComponents(components);

				const $openSubcategory = rp$('.category-wrapper .open-subcategory');
				$openSubcategory.on('click', function openCatMenu(evt) {
					evt.preventDefault();

					const $link = rp$(this);
					const $catId = $link.data('category-id');
					const $catWrap = rp$('.category-wrapper[data-category-id="' + $catId + '"]');
					const $dropWrap = rp$('.category-dropdown[data-category-id="' + $catId + '"]');
					let thisCatOffset = 0;
					let thisCatHeight = 0;

					const $thisArrow = $dropWrap.find('.top-arrow');
					const dropIdHeight = $dropWrap.outerHeight(true);


					// // Toggle
					// // If active, remove classes
					if($catWrap.hasClass('cat_open')) {
						$catWrap.removeClass('cat_open');
						$dropWrap.css({
							'visibility': 'hidden',
							'top': 0
						});
						$catWrap.css('marginBottom', categoryMarginBottom);

						$lastOpenCategory = null;
						$lastOpenDropdown = null;
					} else {
						if ($lastOpenCategory) {
							if($lastOpenCategory.hasClass('cat_open')) {
								$lastOpenCategory.removeClass('cat_open');
								$lastOpenDropdown.css({
									'visibility': 'hidden',
									'top': 0
								});
								$lastOpenCategory.css('marginBottom', categoryMarginBottom);
							}
						}

						// Remove from all other category wraps
						$catWrap.removeClass('cat_open');
						$dropWrap.css({
							'visibility': 'hidden',
							'top': 0
						});
						$catWrap.css('marginBottom', categoryMarginBottom);

						// Set size parameters
						thisCatHeight = $catWrap.outerHeight();
						thisCatOffset = $catWrap.position();

						const openMarginBottom = dropIdHeight + $arrowSize + categoryMarginBottom;

						// Dynamic Location Functions
						$catWrap.addClass('cat_open');
						$catWrap.animate({marginBottom: openMarginBottom }, 0);
						$dropWrap.css('top', thisCatOffset.top + thisCatHeight + $arrowSize);
						$dropWrap.css('visibility', 'visible');
						$thisArrow.css('left', thisCatOffset.left + ($arrowWidth*.5));

						// Smooth-scroll to the clicked-on category so it's clear that the dropdown is appearing
						var pastMobileBreakpoint = (rp$(window).width() <= mobileExperienceBreakpoint);
						$('html, body').animate({
							scrollTop: ($catWrap.offset().top - ((pastMobileBreakpoint) ? 70 : 0)),  // A little extra space to account for the mobile header
						}, 300);

						$lastOpenCategory = $catWrap;
						$lastOpenDropdown = $dropWrap;
					}

				});
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
